<template>
  <div>
    <b-img :src="imgSrc"
           fluid
           alt="Responsive image"
    />
  </div>
</template>

<script>
export default {
  name: "AboutIntro_AboutIntroContent",
  components: {},
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    height: {
      type: Number,
      default: 300
    },
    imgSrc: {
      type: String,
      default: "https://picsum.photos/1024/400/?image=41"
    }
  },
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped></style>
